import { useCustomQuery } from '../query/core/useCustomQuery';
import { userData } from '../../services/api/ai-tools/userData';
import { IUserDataModel } from '../../typings/userData';
import { IResponseData } from '../../typings/common';
import { QueryKeys } from '../../utilities/constants/queryKeys';

export const useUserData = () => {
  const { data, isLoading, isSuccess, error } = useCustomQuery<
    IResponseData<IUserDataModel>
  >([QueryKeys.USER_DATA], () => userData(), {
    suspense: true,
  });

  return {
    data: data?.data,
    error,
    isLoading,
    isSuccess,
  };
};
